module.exports = __webpack_public_path__ + "static/img/passreset.cad0cf07.png";